import { get, post } from './api';
import { CreateEulaAgreementRequestDTO, LatestEulaResponseDTO } from 'declarations/dto/eula';

export const getUsersLatestEulaAgreementStatus = async (id: string) => {
  const response = await get<boolean>(`/eula-user-agreements/user/${id}/latest-status`);

  return response.data;
};

export const getLatestEula = async () => {
  const response = await get<LatestEulaResponseDTO>(`/eulas/latest`);

  return response.data;
};

export const createNewEulaAgreement = async (request: CreateEulaAgreementRequestDTO) => {
  const response = await post<void>(`/eula-user-agreements`, JSON.stringify(request));

  return response.data;
};
